import Modal from '../ui/Modal';
import { useTranslation } from '@/i18n';

interface AcceptCircuitsModalProps {
  closeModal: () => void;
  actionOnClick: () => void;
}

const AcceptCircuitsModal = ({
  closeModal,
  actionOnClick,
}: AcceptCircuitsModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('modal.acceptCircuits.title')}
      closeModal={closeModal}
      actionOnClick={actionOnClick}
      actionTitle={t('modal.acceptCircuits.actionTitle')}
      message={t('modal.acceptCircuits.message')}
    />
  );
};

export default AcceptCircuitsModal;
